import gql from 'graphql-tag'

const DELETE_ORG = gql`
mutation deleteOrganization($organizationId: ID!) {
  deleteOrganization(id: $organizationId)
}
`

export default DELETE_ORG
